import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const BetSummaryWrapper = styled('div', { label: 'BetSummaryWrapper' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const AmountTitle = withConfig(theme => styled('span', { label: 'AmountTitle' })`
    font-size: ${theme.star.fontSize.xSmall};
    line-height: 1.4;
    color: ${theme.star.betslipSummary.txtColor};
    margin-right: 4px;
`);
